import config from 'player/config';
import { base64Decode } from './helpers';

type LicenseRequest = {
    headers: Record<string, string>;
};

export const getDrmConfig = (getDrmToken: () => Promise<string | null>) => {
    const licenseRequestFilter = async (request: LicenseRequest) => {
        const drmToken = await getDrmToken();
        if (drmToken) {
            request.headers['x-dt-auth-token'] = drmToken;
        }
    };

    return {
        widevine: {
            url: config.drmSystems.widevine.licenseUrl,
            licenseRequestFilter,
        },
        playready: {
            url: config.drmSystems.playready.licenseUrl,
            licenseRequestFilter,
        },
        fairplay: {
            certificateUrl: config.drmSystems.fairplay.serverCertificateUrl,
            processSpcUrl: config.drmSystems.fairplay.licenseUrl,
            licenseRequestFilter,
            extractKey: (response: ArrayBuffer) => {
                try {
                    const decodedResponse = base64Decode(
                        new TextDecoder().decode(response).trim(),
                    );

                    return new Uint8Array(decodedResponse.buffer);
                } catch (err) {
                    console.error(err);
                }

                return response;
            },
        },
    };
};
